import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconMagnifyingGlass from "@/app/(components)/generics/Icons/IconMagnifyingGlass";
import { Tooltip, TooltipPosition, TooltipType } from "@/app/(components)/generics/Tootlip/Tooltip";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { ProspectPoolAvailability } from "@/app/types/prospect/ProspectPool";
import { roundedAvailable } from "./ProspectSources.logic";
import styles from "./ProspectSources.module.css";

type Props = {
  pool: ProspectPoolAvailability;
  onOpen?: () => void;
};

export default function ProspectPoolButton(props: Props) {
  const { pool, onOpen } = props;
  const T = useT();

  const hasKeywords = pool.keywords.length > 0;
  const hasSomethingToDo =
    hasKeywords && (!pool.scanned || pool.incoming > 0 || pool.available > 0);
  const isDisabled = !hasSomethingToDo;

  const button = (
    <Button
      isLink={false}
      small={true}
      type={ButtonType.PRIMARY}
      beforeIcon={<IconMagnifyingGlass />}
      text={
        <span className={styles.poolLabel}>
          {T(TKey.PROSPECT_POOL_BUTTON_SEARCH)}
          {pool.available > 0 && (
            <span className={styles.poolCount}>+{roundedAvailable(pool.available)}</span>
          )}
        </span>
      }
      onClick={onOpen}
      disabled={isDisabled}
    />
  );

  if (!isDisabled) {
    return button;
  }

  return (
    <Tooltip
      portal={true}
      type={TooltipType.GREEN}
      position={TooltipPosition.BOTTOM}
      content={T(
        hasKeywords
          ? TKey.PROSPECT_POOL_DISABLED_NOTHING_NEW
          : TKey.PROSPECT_POOL_DISABLED_NO_KEYWORDS,
      )}
      trigger={<span className={styles.poolDisabled}>{button}</span>}
    />
  );
}
